// ja strings for messages/upsell.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const upsell: Dict = {
  "upsell.creator.train.title": "Creatorで学習を始めよう",
  "upsell.creator.train.lead": "ボイスの学習はCreatorプランで使えます。",
  "upsell.creator.train.tick1": "ボイスを無制限に学習",
  "upsell.creator.train.tick2": "Marble Run動画、毎月50コイン",
  "upsell.creator.train.tick3": "今のプランの機能はそのまま",
  "upsell.creator.train.cta": "アップグレードして学習を開始",

  "upsell.creator.export.title": "1080pで書き出し",
  "upsell.creator.export.lead": "Creatorなら動画をフル1080pで書き出せます。",
  "upsell.creator.export.tick1": "1080pで書き出し",
  "upsell.creator.export.tick2": "Marble Run動画、毎月50コイン",
  "upsell.creator.export.tick3": "ボイスを無制限に学習",
  "upsell.creator.export.cta": "アップグレードして1080pで書き出す",

  "upsell.creator.marble.title": "Marble RunはCreatorプランで",
  "upsell.creator.marble.lead":
    "カバーをMarble Run動画に。TikTokやリールにそのまま使えます。",
  "upsell.creator.marble.tick1": "毎月50枚のMarble Runコイン",
  "upsell.creator.marble.tick2": "スタジオから1080pで書き出し",
  "upsell.creator.marble.tick3": "ボイスを無制限に学習",
  "upsell.creator.marble.cta": "アップグレードしてMarble Runを作る",

  "upsell.creator.video.title": "動画作成はCreatorプランで",
  "upsell.creator.video.lead":
    "カバーをシェアできる動画に。TikTokやリールにぴったりです。",
  "upsell.creator.video.tick1": "シェア用の動画、毎月50コイン",
  "upsell.creator.video.tick2": "スタジオから1080pで書き出し",
  "upsell.creator.video.tick3": "ボイスを無制限に学習",
  "upsell.creator.video.cta": "アップグレードして動画を作る",

  "upsell.creator.samplesOne":
    "ボーカル素材の準備ができました：{files}ファイル、{duration}。",
  "upsell.creator.samplesMany":
    "ボーカル素材の準備ができました：{files}ファイル、{duration}。",
  // "<b>{price}|nothing</b> today|toPayToday"
  "upsell.creator.nothing": "お支払いなし",
  "upsell.creator.today": "本日のお支払い",
  "upsell.creator.toPayToday": "（本日）",
  "upsell.creator.thenMonth": "以降は月額{price}",
  "upsell.creator.credited":
    "今月の残り期間分は差し引かれます。いつでも解約できます。",
  "upsell.creator.priceError":
    "アップグレード料金を読み込めませんでした。アップグレードは設定からいつでもできます。",
  "upsell.creator.upgrading": "アップグレード中...",
  "upsell.creator.notNow": "今はしない",
  "upsell.creator.payFailed":
    "お支払いが完了しなかったため、プランは変更されていません。設定でカードを確認して、もう一度お試しください。",

  "upsell.coins.title": "Proコインを購入",
  "upsell.coins.subtitle": "1コインでシェア用の動画を1本作成",
  "upsell.coins.coinAlt": "Proコイン",
  "upsell.coins.useMarble": "Marble Run動画",
  "upsell.coins.useLyric": "歌詞動画",
  "upsell.coins.useTemplates": "すべての動画テンプレート",
  "upsell.coins.bestValue": "いちばんお得",
  "upsell.coins.mostCoins": "コイン最多",
  "upsell.coins.proCoins": "Proコイン",
  "upsell.coins.each": "1枚あたり{price}",
  "upsell.coins.purchase": "購入する",
  "upsell.coins.footer":
    "Proコインはすぐに追加され、有効期限はありません。1コイン＝動画1本。",
};

export default upsell;
